import { faUser } from "@fortawesome/free-solid-svg-icons";
import { isPositiveNumber } from "et3-type-guards";
import i18n from "../../../../constants/i18n";
import getQAStore from "../../../../stores/qa";
import Et3Button from "../../../../core/et3-button";
import { withLiteObserverAndTheme } from "../../../../core/et3-enhanced-render";
import Et3TextInput from "../../../../core/et3-input/et3-text-input";
import Et3Margin from "../../../../core/et3-ui/ET3Margin";
import ET3Div from "../../../../core/et3-div";
import { QA_IOS_RECEIPT_TOKENS_LIMIT } from "../../../../constants/picker-entries-constants";
import Et3Picker from "../../../../core/et3-input/et3-picker";
import { TEt3PickerSingleValue } from "../../../../TypesNEW";

const ObtainIosReceiptTokensForm = withLiteObserverAndTheme((props) => {
  const { theme } = props;
  const { colors } = theme;
  const QaStore = getQAStore();
  const userId = QaStore.receiptUserId.get();

  const isButtonEnabled = isPositiveNumber(userId);

  return (
    <ET3Div
      isScrollable={false}
      isExtendable={false}
      fDirection="column"
      justifyContent="flex-start"
      alignItems="flex-start"
      withShadow={false}
      width={600}
      height={160}
      color={colors.all.transparent}
      style={{}}
      onClick={() => {}}
    >
      <ET3Div
        isScrollable={false}
        isExtendable={false}
        fDirection="row"
        justifyContent="space-between"
        alignItems="flex-start"
        withShadow={false}
        width={600}
        height={80}
        color={colors.all.transparent}
        style={{}}
        onClick={() => {}}
      >
        <Et3TextInput
          size="MEDIUM"
          withShadow={true}
          icon={faUser}
          type={"number"}
          label={i18n.get("USER_ID")}
          placeHolder={i18n.get("USER_ID")}
          value={QaStore.receiptUserId.get()}
          onChoose={(value: number) => {
            return QaStore.setReceiptUserId(value);
          }}
          onBlur={() => {}}
          style={{}}
          onEnter={async () => await QaStore.getReceiptToken()}
        />
        <Et3Picker
          label={i18n.get("LIMIT")}
          options={QA_IOS_RECEIPT_TOKENS_LIMIT}
          value={QaStore.receiptLimit.get()}
          onChoose={(value: TEt3PickerSingleValue) => {
            return QaStore.setReceiptLimit(value);
          }}
          isMultiple={false}
          style={{}}
          onEnter={() => {}}
          onClick={() => {}}
          containerStyle={{}}
        />
      </ET3Div>
      <Et3Margin top={30} bottom={0} left={0} right={0} />
      <Et3Button
        isEnabled={isButtonEnabled}
        onClick={async () => await QaStore.getReceiptToken()}
        text="GET"
        size="LARGE"
        type="GET"
      />
    </ET3Div>
  );
});

export default ObtainIosReceiptTokensForm;
